import { render } from "./ReleaseAccessShow.vue?vue&type=template&id=2efc9874"
import script from "./ReleaseAccessShow.vue?vue&type=script&lang=js"
export * from "./ReleaseAccessShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__